<app-loader></app-loader>
<div *ngIf="!isOnline" class="offline-overlay">
  <div class="offline-box">
    <div class="icon-wrapper">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="50"
        height="50"
        viewBox="0 0 60 50"
        fill="none"
      >
        <path
          d="M49.375 49.5L25.875 25.875C23.9167 26.3333 22.0938 27.0208 20.4062 27.9375C18.7188 28.8542 17.2083 30 15.875 31.375L10.625 26C11.9583 24.6667 13.3958 23.5 14.9375 22.5C16.4792 21.5 18.125 20.625 19.875 19.875L14.25 14.25C12.5417 15.125 10.9479 16.0938 9.46875 17.1563C7.98958 18.2188 6.58333 19.4167 5.25 20.75L0 15.375C1.33333 14.0417 2.71875 12.8438 4.15625 11.7813C5.59375 10.7188 7.125 9.70833 8.75 8.75L3.5 3.5L7 0L53 46L49.375 49.5ZM30 45.5C28.25 45.5 26.7708 44.8854 25.5625 43.6563C24.3542 42.4271 23.75 40.9583 23.75 39.25C23.75 37.5 24.3542 36.0208 25.5625 34.8125C26.7708 33.6042 28.25 33 30 33C31.75 33 33.2292 33.6042 34.4375 34.8125C35.6458 36.0208 36.25 37.5 36.25 39.25C36.25 40.9583 35.6458 42.4271 34.4375 43.6563C33.2292 44.8854 31.75 45.5 30 45.5ZM44.75 30.625L32.125 18C35.5 18.3333 38.6562 19.1875 41.5938 20.5625C44.5313 21.9375 47.125 23.75 49.375 26L44.75 30.625ZM54.75 20.75C51.5417 17.5417 47.8229 15.0313 43.5938 13.2188C39.3646 11.4063 34.8333 10.5 30 10.5C29.125 10.5 28.2812 10.5312 27.4688 10.5938C26.6562 10.6563 25.8333 10.75 25 10.875L18.625 4.5C20.4583 4 22.3229 3.625 24.2188 3.375C26.1146 3.125 28.0417 3 30 3C35.9167 3 41.4375 4.10417 46.5625 6.3125C51.6875 8.52083 56.1667 11.5417 60 15.375L54.75 20.75Z"
          fill="#014221"
        />
      </svg>
    </div>
    <h2>No Internet Connection</h2>
    <p>Couldn't connect to the internet. Please check your settings.</p>
    <button (click)="retryConnection()">Retry</button>
  </div>
</div>

<div *ngIf="isOnline">
  <div *ngIf="showOnlineMessage" class="online-banner">✅ Back online</div>
  <app-cookies-consent></app-cookies-consent>
  <router-outlet></router-outlet>
</div>
